import { ProductCode } from './product.model';
import { SlotCode } from './slot.model';

export const LOCAL_STORAGE_VOUCHER_KEY = 'voucher';

export type CreditRedemptionTimeUnit = 'DAY' | 'HOUR' | 'MINUTE' | 'SECOND';

export const CREDIT_REDEMPTION_TIME_LEFT_KEYS: Record<
  CreditRedemptionTimeUnit,
  { singular: string; plural: string }
> = {
  DAY: { singular: 'CREDIT_REDEMPTION.DAY_LEFT', plural: 'CREDIT_REDEMPTION.DAYS_LEFT' },
  HOUR: { singular: 'CREDIT_REDEMPTION.HOUR_LEFT', plural: 'CREDIT_REDEMPTION.HOURS_LEFT' },
  MINUTE: { singular: 'CREDIT_REDEMPTION.MINUTE_LEFT', plural: 'CREDIT_REDEMPTION.MINUTES_LEFT' },
  SECOND: { singular: 'CREDIT_REDEMPTION.SECOND_LEFT', plural: 'CREDIT_REDEMPTION.SECONDS_LEFT' },
};

export enum CreditRedemptionState {
  Active = 'active',
  Expired = 'expired',
  Stopped = 'stopped',
  Pending = 'pending',
  Inactive = 'inactive',
  Draft = 'draft', // draft? 🧐
}

export interface CreditRedemptionTimeLeft {
  unit: CreditRedemptionTimeUnit;
  value: number;
}

export interface CreditRedemptionInformation {
  // Optional: credit resource may be unreachable when wallet was unshared.
  productName?: string;
  productCode?: ProductCode | SlotCode;
  status: CreditRedemptionState;
  relevantDate: unknown | Date | string;
  timeLeft: CreditRedemptionTimeLeft | null;
}
